module.exports = __webpack_public_path__ + "./assets/ab5ddc4a1ab6e1073dc71688dfd919dd.woff";